module.exports = __webpack_public_path__ + "static/media/staff5.ae94f439.png";